    <template>
      <div class="d-none d-sm-none d-md-flex rounded-0">

        <!--desktop-->
        <v-carousel v-if="imagesGallery.length > 0"
        show-arrows="hover"
        hide-delimiters
        height="200"
        >
          <v-carousel-item
            v-for="(img, index) in imagesGallery"
            :key="index"
            :title="img.title"
            :content="img.license"
            :src="img.link"
            cover
          >
  <div class="px-lg-4">
            <v-btn
              class="d-none d-sm-none d-md-flex rounded-0"
              variant="flat"
              color="accent"
              @click="overlay = !overlay, imgsrc = img.link"
              >
                Full
            </v-btn>
  </div>

          </v-carousel-item>
        </v-carousel>
        <v-dialog v-model="overlay" fullscreen>
              <v-card class="overflow-auto rounded-0">
                <v-img 
                  :src="imgsrc"
                > 
                  <v-btn
                    rounded="0"
                    variant="flat"
                    color="regular"
                    @click.stop="overlay = !overlay"
                  >
                    Close
                  </v-btn>
                </v-img>
              </v-card>
            </v-dialog>
      </div>
      <div class="d-flex d-sm-none d-none d-sm-flex d-md-none"><!--mobile-->
        <v-carousel v-if="imagesGallery.length > 0"
          :show-arrows="false"
          height="400"
        >
          <v-carousel-item
            v-for="(img, index) in imagesGallery"
            :key="index"
            :title="img.title"
            :content="img.license"
            :src="img.link"
            cover
          >
          </v-carousel-item>
        </v-carousel>
      </div>  
    </template>
  

  
  
  <script>
  
  export default {
      name: 'image-gallery',
      props:['column', 'modelValue', 'imgtitle'],
      emits: ['update:modelValue'],
      components: {
  
      },
      data(){
      return {
      v: this.modelValue,
      showimagedialog: false, 
      overlay: false,
      imgsrc: '',

      prefixpath: this.$store.state.mainurl+"/image/data?image=",
      prefixsmall: "",
      prefixfull: "",

  /*
      breakpoints: {
  
          1500: {
            slideRatio: 2 / 3
          },
          900: {
            slideRatio: 1
          },
        },
  */
  
      }
      },
      methods:{
          handleInput (e) {            
             this.v = e.target.value;            
             this.$emit('update:modelValue', this.v);
             this.dialogVisible = false;
          },
          showDialog() {
              this.dialogVisible = true;
          }
  
      }, 
      computed:{
//       imagesGallery: function(){
//         if (this.modelValue == '' || this.modelValue == null || this.modelValue == "null" || this.modelValue == undefined || this.modelValue == []) {  // checking undefined values - so ok? or undefined or null?
//             return "undefined"; // end of checking
//         } else {
//           let images=JSON.parse(this.modelValue);
//           for(var i=0; i<images.length; i++){
//             images[i].link=this.$store.state.mainurl+"/image/data?image="+images[i].link;
//           }
// //  console.log(images);
//           return images;
//         }
          
//       },

      imagesGallery: function(){
//console.log(this.modelValue)
        // проверка с ИЛИ должна быть "позитивной", иначе проверка выйдет из первого же вхождения "неравенства" и остальные не затронет
          if (this.modelValue == '' || this.modelValue == null || this.modelValue == "null" || this.modelValue == undefined || this.modelValue == []) { 
 // checking undefined values - so ok? // or null or undefined?
            return ''; // end of checking
        } else {
          let images=JSON.parse(this.modelValue);
  //        let images=this.vparsed;
          for(var i=0; i<images.length; i++){
            // if (images[i].link.includes('/')) {
            //       this.prefixsmall = images[i].link.slice(0,7)+"/small_";
            //       this.prefixfull = images[i].link.slice(0,7)
            //       images[i].link=images[i].link.slice(8);
            // }
            // else {
            //   images[i].link=images[i].link
            //   this.prefixsmall = "small_";
            //   this.prefixfull = "";
            // }
            images[i].link=images[i].link
            images[i].source=images[i].source
            images[i].middle=images[i].middle
            images[i].small=images[i].small
          }
          return images;
        }  
      },






    } 
  }
  </script>
  